export default __webpack_public_path__ + "static/media/verlinde-white.fa27f7a2.svg";